import React from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {Styles} from './Styles';


interface Props {
    up():void,
    next():void,
    isLock:boolean,
    isNext:boolean,
}

const MoveButton = (props:Props)=> {
    const classes = Styles.base();
    const up = ()=>{
        if( !props.isLock ){
            props.up();
        }
    }
    const next = ()=>{
        if( !props.isLock ){
            props.next();
        }
    }
    return (
        <React.Fragment>
            <Tooltip title="次の部屋へ"><Button variant="text" style={{color:"white"}} onClick={up}>
                <ArrowUpwardIcon className={classes.extendedIcon} />
                上の階へ
            </Button></Tooltip>
            <div className={classes.grow}/>
            {props.isNext &&
            <Tooltip title="次の部屋へ"><Button variant="text" style={{color:"white"}} onClick={next}>
                次の部屋へ
                <ArrowForwardIcon className={classes.extendedIcon}/>
            </Button></Tooltip>
            }
        </React.Fragment>
    );
}

//<Fab color="secondary" aria-label="add" className={classes.fabButton}>
//<AddIcon />
//</Fab>

export default MoveButton;
